export const triggerBrowserNotification = async (title: string, body: string, onClickCallback?: () => void) => {
	if (!('Notification' in window)) {
		console.warn('Este navegador não suporta notificações de desktop.');
		return;
	}
	let permission = Notification.permission;
	if (permission === 'default') {
		permission = await Notification.requestPermission();
	}
	if (permission === 'granted') {
		const notification = new Notification(title, {
			body: body,
			icon: '/images/icone.png',
		});
		notification.onclick = (event) => {
			event.preventDefault();
			window.focus();
			notification.close();
			if (onClickCallback) {
				onClickCallback();
			}
		};
	}
};